module.exports = __webpack_public_path__ + "images/emoji/bouquet.c8c1fd5fef72dae9db4e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bouquet.png
// module id = CTj2
// module chunks = 13